/*
 * @Descripttion: 上传文件（图片或视频）
 * @Author: juanjuanhui
 * @Date: 2021-05-18 15:37:01
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2021-07-28 21:50:44
 */
import axios from 'axios'
import sha1 from 'utils/sha1'
import { base } from './base'
import { formatDate } from '@/utils/formatDate'
import { Message } from 'element-ui'
const timeFn = timestamp => {
  const token = sha1.sha1('ChuangXinQuChengNongJi360YuRunSiJi' + timestamp)
  const date = new Date(Math.floor(new Date().getTime()))
  const yyyy = formatDate(date, 'yyyy')
  const mm = formatDate(date, 'yyyy-MM').split('-')[1]
  const dd = formatDate(date, 'yyyy-MM-dd').split('-')[2]
  const hh = formatDate(date, 'yyyy-MM-dd hh').split(' ')[1]
  const ii = formatDate(date, 'yyyy-MM-dd hh:mm')
    .split(' ')[1]
    .split(':')[1]
  const ss = formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    .split(' ')[1]
    .split(':')[2]
  const rand6 = mathRand()
  return {
    token,
    date,
    yyyy,
    mm,
    dd,
    hh,
    ii,
    ss,
    rand6
  }
}
const mathRand = () => {
  var num = ''
  for (var i = 0; i < 6; i++) {
    num += Math.floor(Math.random() * 10)
  }
  return num
}
// const rand6 = mathRand()
export const uploadImg = content => {
  console.log(content);
  let ysbUrl = 'ysb/product'
  if (content.data.stype) {
    ysbUrl = content.data.stype
  }
  let timestamp = Math.floor(new Date().getTime() / 1000)
  let { token, yyyy, mm, dd, hh, ii, ss, rand6 } = timeFn(timestamp)
  // 创建form对象
  let params = new FormData(),
    url = ''
  params.append('timestamp', timestamp)
  params.append('token', token)
  params.append('Filedata', content.file, content.file.name)
  if (content.data.type == 'image') {
    if (content.data.editor) {
      params.append('upfile', content.file, content.file.name)
      url = `${base.upload}/ueditor/controller.php?action=uploadimage&imagePathFormat=/n/${ysbUrl}/${yyyy}/${mm}/${dd}${hh}${ii}${ss}${rand6}`
    } else {
      url = `${base.upload}/upload.php`
      params.append('xtype', content.data.xtype)
    }
  } else if (content.data.type == 'video') {
    url = `${base.video}/uploadVideo.php?type=${content.data.xtype}`
  } else {
    url = `${base.upload}/upload.php`
    params.append('xtype', content.data.xtype)
  }

  return new Promise((resolve,reject) => {
    axios.post(url, params, {
      onUploadProgress: event => {
        content.file.percent = (event.loaded / event.total) * 100
        if (content.onProgress) {
          content.onProgress(content.file)
        }
      }
    }).then( res => {
      if(res.data.status == 111111){
        resolve(res);
      }else{
        Message.error(res.data.message);
        reject(res);
      }
    }).catch( res => {
      Message.error("服务器异常，请重新上传");
      reject(res)
    })
  })
}
